import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "upload-header py-1 d-flex" }
const _hoisted_2 = { class: "d-inline me-auto" }
const _hoisted_3 = {
  key: 0,
  class: "upload-document"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary border border-primary"
}, "Add Documents", -1 /* HOISTED */)
const _hoisted_5 = { class: "upload-filters" }
const _hoisted_6 = { class: "upload-body" }
const _hoisted_7 = {
  key: 0,
  class: "new-documents pb-4"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "table table-responsive-md borderless" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("Type "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_11 = ["value", "disabled"]
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_14 = { class: "text-end align-middle" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "upload-footer pt-2 pb-3 d-flex align-items-center justify-content-end" }
const _hoisted_20 = { class: "more-files-wrapper me-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", { href: "javascript:void(0);" }, "Add Another Document", -1 /* HOISTED */)
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }),
  /*#__PURE__*/_createTextVNode(" Uploading")
], -1 /* HOISTED */)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "table table-responsive-md borderless" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Modified"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-8" })
], -1 /* HOISTED */)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-6" })
], -1 /* HOISTED */)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-6" })
], -1 /* HOISTED */)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-4" })
], -1 /* HOISTED */)
const _hoisted_36 = [
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-file me-2 fa-lg" }, null, -1 /* HOISTED */)
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "text-end" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* HOISTED */)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye" }, null, -1 /* HOISTED */)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 1,
  class: "text-default"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_TableEmpty = _resolveComponent("TableEmpty")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.title), 1 /* TEXT */),
      (_ctx.fileDetails.length <= 0 && _ctx.addPatientDocumentsPermission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("input", {
              type: "file",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadFilesChanged($event))),
              class: "file-input",
              multiple: ""
            }, null, 32 /* HYDRATE_EVENTS */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "document-filters")
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.fileDetails.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (!_ctx.uploading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("table", _hoisted_9, [
                    _hoisted_10,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileDetails, (fileDetail, index) => {
                      return (_openBlock(), _createElementBlock("tbody", {
                        class: "hh-document-table",
                        key: index
                      }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            (fileDetail.type)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass(`file-icon far fa-file ${_ctx.getFileIcon(fileDetail.type)}`)
                                }, null, 2 /* CLASS */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("input", {
                              type: "text",
                              placeholder: "Enter Name",
                              class: "form-control",
                              value: fileDetail.file.name,
                              disabled: _ctx.uploading
                            }, null, 8 /* PROPS */, _hoisted_11)
                          ]),
                          _createElementVNode("td", _hoisted_12, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_TypeaheadInput, {
                                placeholder: "Start Typing...",
                                data: _ctx.searchedTypes,
                                value: _ctx.selectedUploadType,
                                onValueChanged: (newValue) => _ctx.updateTypeId(index, newValue.value),
                                onBlurredInput: ($event: any) => (_ctx.v$.fileDetails[index].uploadTypeId.$touch()),
                                disabled: _ctx.uploading,
                                showAllByDefault: true,
                                openOnFocus: true
                              }, null, 8 /* PROPS */, ["data", "value", "onValueChanged", "onBlurredInput", "disabled"]),
                              (_ctx.isFieldRequired(index))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Type is required."))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_14, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-outline-danger",
                              onClick: ($event: any) => (_ctx.removeFile(index))
                            }, _hoisted_18, 8 /* PROPS */, _hoisted_15)
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _createElementVNode("footer", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("input", {
                        type: "file",
                        class: "file-input",
                        multiple: "",
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadFilesChanged($event))),
                        disabled: _ctx.uploading
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_22)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-xs btn-primary me-2",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadDocuments())),
                      disabled: _ctx.uploading
                    }, " Save Documents ", 8 /* PROPS */, _hoisted_23),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-xs btn-outline-primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.removeAllFiles())),
                      disabled: _ctx.uploading
                    }, " Cancel ", 8 /* PROPS */, _hoisted_24)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("table", _hoisted_28, [
        _hoisted_29,
        (_ctx.patientDocuments?.length == 0 && !_ctx.loadingDocuments)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_30, [
              _createVNode(_component_TableEmpty, {
                "col-span": 5,
                component: "documents",
                "secondary-message": "No Documents Found"
              })
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_31, [
              (_ctx.loadingDocuments)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, _hoisted_36))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (!_ctx.loadingDocuments)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.patientDocuments, (document) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: document.Id
                    }, [
                      _createElementVNode("td", null, [
                        _hoisted_37,
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.downloadDocuments(document))
                        }, _toDisplayString(document.DocumentName), 9 /* TEXT, PROPS */, _hoisted_38)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(document?.DocumentTypeName), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(document.ModifiedDateFormatted)), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_39, [
                        (_ctx.editPatientDocumentsPermission || _ctx.deletePatientDocumentsPermission)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (
                                            _ctx.editPatientDocumentsPermission && !document.hasOwnProperty('IsPatientChart')
                                        )
                                ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn table-btn btn-outline-info au-target",
                                    onClick: ($event: any) => (_ctx.editSelectedDocument(document))
                                  }, _hoisted_42, 8 /* PROPS */, _hoisted_40)), [
                                    [_directive_tooltip, { title: 'Edit' }]
                                  ])
                                : _createCommentVNode("v-if", true),
                              (
                                            _ctx.deletePatientDocumentsPermission &&
                                            !document.hasOwnProperty('IsPatientChart')
                                        )
                                ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "btn table-btn btn-outline-danger",
                                    onClick: ($event: any) => (_ctx.deleteSelectedDocument(document?.Id))
                                  }, _hoisted_45, 8 /* PROPS */, _hoisted_43)), [
                                    [_directive_tooltip, { title: 'Delete' }]
                                  ])
                                : _createCommentVNode("v-if", true),
                              (document.IsPatientChart && document.Status != 'Running' && document.Status != 4)
                                ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    type: "button",
                                    class: "btn table-btn btn-outline-info au-target",
                                    onClick: ($event: any) => (_ctx.openSelectedDocument(document))
                                  }, _hoisted_48, 8 /* PROPS */, _hoisted_46)), [
                                    [_directive_tooltip, { title: 'View' }]
                                  ])
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_openBlock(), _createElementBlock("i", _hoisted_49, "No Actions"))
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]))
      ])
    ])
  ]))
}